<template>
  <teleport to="body">
    <div class="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center p-4 z-50 transition-opacity duration-300 animate-modalFade">
      <div class="w-full max-w-4xl bg-gray-800 text-gray-300 rounded-lg shadow-lg border border-gray-700 overflow-hidden animate-scaleIn flex flex-col" style="max-height:60vh;">
        <!-- Header -->
        <header class="bg-gray-800 border-b border-gray-700">
          <div class="flex items-center justify-between p-4">
            <div class="flex items-center space-x-3">
              <i class="fa-solid fa-tower-observation text-indigo-400 text-base"></i>
              <h2 class="text-sm sm:text-base font-semibold text-indigo-200">บุกยึด Outpost ({{ timeLeft }}) </h2>
              <span class="inline-flex items-center gap-1 px-2 py-1 rounded-md text-xxs font-medium border border-indigo-500 border-opacity-40 bg-indigo-600 bg-opacity-20 text-indigo-200">
                      รอบที่ <span class="font-bold">{{ currentRound }}</span>
                    </span>
            </div>
            <button @click="emitClose" class="text-gray-300 hover:text-red-500 transition-colors duration-200 p-2" aria-label="ปิด">
              <i class="fas fa-minus text-lg"></i>
            </button>
          </div>
          <nav class="flex border-b border-gray-600">
            <button
              v-for="tab in tabs"
              :key="tab.id"
              @click="activeTab = tab.id"
              class="relative px-3 sm:px-4 py-2 text-xs sm:text-sm font-medium transition-colors duration-200 flex items-center justify-center space-x-2"
              :class="activeTab === tab.id ? 'bg-gray-600 text-gray-100 border-b-2 border-indigo-500' : 'text-gray-300 hover:bg-gray-600'"
            >
              <i :class="tab.icon"></i>
              <span>{{ tab.name }}</span>
            </button>
          </nav>
        </header>

        <!-- Content -->
        <main class="flex-1 overflow-y-auto p-4 space-y-4 scrollbar-thin">
          <section class="space-y-4 animate-fadeIn">
            <!-- TAB: CURRENT -->
            <div v-if="activeTab === 'current'" class="space-y-4">

              <!-- ⬇️ สถานะเหตุการณ์ (ดีไซน์ใหม่) -->
              <div >

                <!-- Content -->
                <div v-if="specialEvent" class="space-y-3 bg-gray-900 border border-gray-700 rounded-md p-4">
                  <!-- แถวชื่อเหตุการณ์ + ฝ่ายที่ได้โบนัส -->
                  <div class="flex items-center justify-between gap-2">
                    <div class="flex items-center gap-2">
                      <i class="fa-solid fa-bolt text-yellow-300"></i>
                      <p class="text-sm">
                        <span class="text-yellow-200 font-semibold">สถานการณ์พิเศษ</span> :
                        <span class="text-gray-100 font-medium">{{ specialEvent.name }}</span>
                      </p>
                    </div>

                    <span
                      class="inline-flex items-center gap-1 px-2 py-1 rounded-md text-xxs font-medium border"
                      :class="bonusSideClassInline"
                      aria-label="ฝ่ายที่ได้รับโบนัส"
                    >
                      <i class="fa-solid" :class="bonusSideIcon"></i>
                      {{ bonusSideLabel }}
                    </span>
                  </div>

                  <!-- Tiles 3 ช่อง -->
                  <div class="grid grid-cols-2  gap-2">

                    <div class="rounded-md p-3 border border-gray-700 bg-gray-800 bg-opacity-70">
                      <div class="flex items-center justify-between">
                        <span class="text-xxs text-gray-400">ลูกเต๋าที่เพิ่ม</span>
                        <span class="text-sm text-gray-100 mono">+{{ specialEvent.bonusDice }}</span>
                      </div>
                    </div>
                    <div class="rounded-md p-3 border border-gray-700 bg-gray-800 bg-opacity-70">
                      <div class="flex items-center justify-between">
                        <span class="text-xxs text-gray-400">เหลือกี่รอบ</span>
                        <span class="text-sm text-gray-100 mono">{{ specialEvent.roundsLeft }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- รวมพลังชีวิตทั้งหมด (แดง vs น้ำเงิน) -->
              <div v-if="attackersData.length || defendersData.length" class="bg-gray-900 border border-gray-700 rounded-md p-4">
                <div class="flex items-center justify-between text-xs text-gray-300 mb-2">
                  <div class="flex items-center space-x-2">
                    <span class="px-2 py-1 rounded bg-red-700 text-white text-xxs">ฝ่ายบุก</span>
                    <span class="font-mono text-gray-100">{{ totalAtkHp }} / {{ totalAtkMax }}</span>
                  </div>
                  <div class="hidden sm:block text-gray-500 text-xxs">รวมพลังชีวิตทั้งหมด</div>
                  <div class="flex items-center space-x-2">
                    <span class="font-mono text-gray-100 text-right">{{ totalDefHp }} / {{ totalDefMax }}</span>
                    <span class="px-2 py-1 rounded bg-blue-700 text-white text-xxs">ฝ่ายป้องกัน</span>
                  </div>
                </div>

                <div class="relative w-full bg-gray-500 h-5 rounded overflow-hidden">
                  <!-- ฝ่ายบุก -->
                  <div class="absolute inset-y-0 left-0 bg-red-600 transition-all duration-300" :style="{ width: atkPct + '%' }"></div>
                  <!-- ฝ่ายป้องกัน -->
                  <div class="absolute inset-y-0 right-0 bg-blue-600 transition-all duration-300" :style="{ width: defPct + '%' }"></div>
                  <!-- เส้นแบ่ง -->
                  <div v-if="totalAllHp > 0" class="absolute top-0 bottom-0 bg-gray-200" style="width: 2px;" :style="{ left: atkPct + '%' }"></div>
                </div>

                <div class="flex items-center justify-between text-xxs mt-2">
                  <span class="text-red-300 font-semibold">{{ atkPct.toFixed(1) }}% ฝ่ายบุก</span>
                  <span class="text-gray-400">VS</span>
                  <span class="text-blue-300 font-semibold">ฝ่ายป้องกัน {{ defPct.toFixed(1) }}%</span>
                </div>
              </div>

              <!-- ปุ่มทอย + Auto Roll + สรุปผลแบบกระชับ -->
              <div class="space-y-3">
                <!-- ปุ่มทอยหลัก -->
                <button
                  class="w-full px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white text-sm rounded-md font-semibold transition-all duration-200 flex items-center justify-center gap-2 group disabled:opacity-60 disabled:cursor-not-allowed"
                  @click="fightRound"
                  :disabled="eventData?.finished || isProcessing || !attackerSelectedData || !defenderSelectedData || isAutoRolling"
                  aria-live="polite"
                >
                  <i :class="isProcessing ? 'fa-solid fa-spinner animate-spin-pulse' : 'fa-solid fa-dice text-xs group-hover:animate-pulse'"></i>
                  <span>{{ isProcessing ? 'กำลังทอย...' : 'ทอยลูกเต๋าต่อสู้' }}</span>
                </button>

                <!-- ปุ่ม Auto Roll (คล้าย zombie auto-attack) -->
                <div class="flex gap-2">
                  <button
                    @click="toggleAutoRoll(250)"
                    class="w-full px-4 py-2 text-white text-sm rounded-md font-semibold transition-all duration-200 flex items-center justify-center gap-2 group"
                    :class="isAutoRolling && autoRollIntervalMs === 250 ? 'bg-red-600 hover:bg-red-700' : 'bg-indigo-600 hover:bg-indigo-700'"
                    :disabled="!isAutoRolling && (eventData?.finished || isProcessing || !attackerSelectedData || !defenderSelectedData)"
                  >
                    <div v-if="isProcessing && isAutoRolling && autoRollIntervalMs === 250" class="animate-spin-pulse rounded-full h-4 w-4 border-t-2 border-white"></div>
                    <i v-else class="fas fa-robot text-xs group-hover:animate-pulse"></i>
                    {{ isAutoRolling && autoRollIntervalMs === 250 ? '(0.25s)' : '(0.25s)' }}
                  </button>
                  <button
                    @click="toggleAutoRoll(500)"
                    class="w-full px-4 py-2 text-white text-sm rounded-md font-semibold transition-all duration-200 flex items-center justify-center gap-2 group"
                    :class="isAutoRolling && autoRollIntervalMs === 500 ? 'bg-red-600 hover:bg-red-700' : 'bg-indigo-600 hover:bg-indigo-700'"
                    :disabled="!isAutoRolling && (eventData?.finished || isProcessing || !attackerSelectedData || !defenderSelectedData)"
                  >
                    <div v-if="isProcessing && isAutoRolling && autoRollIntervalMs === 500" class="animate-spin-pulse rounded-full h-4 w-4 border-t-2 border-white"></div>
                    <i v-else class="fas fa-robot text-xs group-hover:animate-pulse"></i>
                    {{ isAutoRolling && autoRollIntervalMs === 500 ? '(0.5s)' : '(0.5s)' }}
                  </button>
                  <button
                    @click="toggleAutoRoll(1000)"
                    class="w-full px-4 py-2 text-white text-sm rounded-md font-semibold transition-all duration-200 flex items-center justify-center gap-2 group"
                    :class="isAutoRolling && autoRollIntervalMs === 1000 ? 'bg-red-600 hover:bg-red-700' : 'bg-indigo-600 hover:bg-indigo-700'"
                    :disabled="!isAutoRolling && (eventData?.finished || isProcessing || !attackerSelectedData || !defenderSelectedData)"
                  >
                    <div v-if="isProcessing && isAutoRolling && autoRollIntervalMs === 1000" class="animate-spin-pulse rounded-full h-4 w-4 border-t-2 border-white"></div>
                    <i v-else class="fas fa-robot text-xs group-hover:animate-pulse"></i>
                    {{ isAutoRolling && autoRollIntervalMs === 1000 ? '(1s)' : '(1s)' }}
                  </button>
                </div>

                <!-- สรุปผลรอบล่าสุด -->
                <div
                  v-show="isProcessing || attackerDiceResults.length || defenderDiceResults.length"
                  class="bg-gray-900 border border-gray-700 rounded-md p-4"
                >
                  <!-- แถวสรุปผล -->
                  <div class="flex justify-between gap-2 mb-2">
                    <div class="flex items-center gap-2">
                      <span class="badge badge-red">ฝ่ายบุก</span>
                      <span class="mono text-gray-100">รวม: {{ attackerSum }}</span>
                    </div>
                    <div class="text-center text-xxs text-gray-400">VS</div>
                    <div class="flex items-center gap-2 justify-end">
                      <span class="mono text-gray-100">รวม: {{ defenderSum }}</span>
                      <span class="badge badge-blue">ฝ่ายป้องกัน</span>
                    </div>
                  </div>

                  <!-- ป้ายผู้ชนะ -->
                  <div v-if="!isProcessing && (attackerDiceResults.length || defenderDiceResults.length)" class="mt-2">
                    <div
                      class="inline-flex items-center gap-2 px-2 py-1 rounded-md border text-xxs"
                      :class="winnerSide === 'attacker'
                        ? 'bg-red-900 bg-opacity-50 border-red-700 text-red-200'
                        : winnerSide === 'defender'
                          ? 'bg-blue-900 bg-opacity-50 border-blue-700 text-blue-200'
                          : 'bg-gray-800 border-gray-700 text-gray-300'"
                    >
                      <i class="fa-solid" :class="winnerSideIcon"></i>
                      <span>{{ winnerLabel }}</span>
                    </div>
                  </div>

                  <!-- แถวลูกเต๋า -->
                  <div class="mt-3 grid grid-cols-2 gap-3">
                    <!-- ฝ่ายบุก -->
                    <div>
                      <div class="flex items-center justify-between text-xxs mb-1">
                        <span class="text-red-300">ฝ่ายบุก</span>
                        <span class="text-gray-400">ลูกเต๋า: {{ attackerDiceCount }}</span>
                      </div>
                      <div class="dice-row">
                        <template v-if="isRolling">
                          <span v-for="(d, i) in tempAttackerDices" :key="'atk-temp-'+i" class="die die-red shimmer">{{ d }}</span>
                        </template>
                        <template v-else>
                          <span v-for="(d, i) in attackerDiceResults" :key="'atk-'+i" class="die die-red">{{ d }}</span>
                        </template>
                      </div>
                    </div>

                    <!-- ฝ่ายป้องกัน -->
                    <div>
                      <div class="flex items-center justify-between text-xxs mb-1">
                        <span class="text-blue-300">ฝ่ายป้องกัน</span>
                        <span class="text-gray-400">ลูกเต๋า: {{ defenderDiceCount }}</span>
                      </div>
                      <div class="dice-row">
                        <template v-if="isRolling">
                          <span v-for="(d, i) in tempDefenderDices" :key="'def-temp-'+i" class="die die-blue shimmer">{{ d }}</span>
                        </template>
                        <template v-else>
                          <span v-for="(d, i) in defenderDiceResults" :key="'def-'+i" class="die die-blue">{{ d }}</span>
                        </template>
                      </div>
                    </div>
                  </div>

                  <!-- บันทึกรอบล่าสุด -->
                  <div class="mt-3" v-if="fightResult?.length">
                    <div class="flex flex-wrap gap-2 text-xs text-gray-300">
                      <span
                        v-for="(res, i) in fightResult"
                        :key="i"
                        class="inline-flex items-center gap-1 px-2 py-1 rounded-md border border-gray-700 bg-gray-800"
                      >
                        <i class="fa-solid fa-chevron-right text-gray-500"></i>
                        <span>{{ res.message }}</span>
                      </span>
                    </div>
                  </div>

                  <p class="mt-3 text-xs text-gray-500 italic" v-else-if="isProcessing">กำลังคำนวณผลลัพธ์...</p>
                  <p class="mt-3 text-xs text-gray-500 italic" v-else>ยังไม่มีผลการทอย</p>
                </div>
              </div>

              <!-- ผู้ต่อสู้ปัจจุบัน -->
              <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <!-- Attacker card -->
                <div v-if="attackerSelectedData" class="bg-gray-900 border border-gray-700 rounded-md p-4">
                  <div class="flex items-center justify-between mb-2">
                    <div class="flex items-center space-x-2">
                      <span class="px-2 py-1 rounded bg-red-700 text-white text-xxs">ฝ่ายบุก</span>
                      <span class="text-xs text-gray-300">ลูกเต๋าโจมตี: <span class="font-mono text-red-300">6</span></span>
                    </div>
                    <span v-if="attackerSelectedData?.level || gameVillagersData?.[attackerSelectedData?.templateId]?.level" class="text-xxs text-gray-400">
                      Lv. {{ attackerSelectedData?.level ?? gameVillagersData?.[attackerSelectedData?.templateId]?.level }}
                    </span>
                  </div>
                  <div class="flex items-center space-x-3">
                    <img
                      :src="attackerSelectedData?.img || gameVillagersData?.[attackerSelectedData?.templateId]?.normalFace || 'https://via.placeholder.com/80?text=No+Img'"
                      class="w-16 h-16 rounded-md object-cover border-2 border-red-600 bg-gray-800"
                      @error="handleImageError" :alt="attackerSelectedData.name"
                    />
                    <div class="flex-1 min-w-0">
                      <div class="flex items-center justify-between">
                        <h4 class="text-sm font-semibold text-gray-100 truncate">{{ attackerSelectedData.name }}</h4>
                      </div>
                      <div class="mt-2">
                        <div class="flex items-center justify-between text-xxs text-gray-400">
                          <span>HP</span>
                          <span class="font-mono text-gray-200">{{ getHp(attackerSelectedData) }} / {{ getMaxHp(attackerSelectedData) }}</span>
                        </div>
                        <div class="relative w-full bg-gray-500 h-5 rounded overflow-hidden mt-1">
                          <div class="absolute inset-y-0 left-0 bg-red-600" :style="{ width: (getHp(attackerSelectedData) / getMaxHp(attackerSelectedData) * 100) + '%' }"></div>
                        </div>
                      </div>
                      <div class="mt-2 grid grid-cols-3 gap-1 text-xxs text-gray-300">
                        <div class="px-2 py-1 rounded bg-gray-800 border border-gray-700">STA {{ getTotalStat(attackerSelectedData, 'stamina') }}</div>
                        <div class="px-2 py-1 rounded bg-gray-800 border border-gray-700">STR {{ getTotalStat(attackerSelectedData, 'str') }}</div>
                        <div class="px-2 py-1 rounded bg-gray-800 border border-gray-700">INT {{ getTotalStat(attackerSelectedData, 'int') }}</div>
                        <div class="px-2 py-1 rounded bg-gray-800 border border-gray-700">AGI {{ getTotalStat(attackerSelectedData, 'agi') }}</div>
                        <div class="px-2 py-1 rounded bg-gray-800 border border-gray-700">LUCK {{ getTotalStat(attackerSelectedData, 'luck') }}</div>
                        <div class="px-2 py-1 rounded bg-gray-800 border border-gray-700">DEF {{ getTotalStat(attackerSelectedData, 'defense') }}</div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Defender card -->
                <div v-if="defenderSelectedData" class="bg-gray-900 border border-gray-700 rounded-md p-4">
                  <div class="flex items-center justify-between mb-2">
                    <div class="flex items-center space-x-2">
                      <span class="px-2 py-1 rounded bg-blue-700 text-white text-xxs">ฝ่ายป้องกัน</span>
                      <span class="text-xs text-gray-300">ลูกเต๋าป้องกัน: <span class="font-mono text-blue-300">6</span></span>
                    </div>
                    <span v-if="defenderSelectedData?.level || gameVillagersData?.[defenderSelectedData?.templateId]?.level" class="text-xxs text-gray-400">
                      Lv. {{ defenderSelectedData?.level ?? gameVillagersData?.[defenderSelectedData?.templateId]?.level }}
                    </span>
                  </div>
                  <div class="flex items-center space-x-3">
                    <img
                      :src="defenderSelectedData?.img || gameVillagersData?.[defenderSelectedData?.templateId]?.normalFace || 'https://via.placeholder.com/80?text=No+Img'"
                      class="w-16 h-16 rounded-md object-cover border-2 border-blue-600 bg-gray-800"
                      @error="handleImageError" :alt="defenderSelectedData.name"
                    />
                    <div class="flex-1 min-w-0">
                      <div class="flex items-center justify-between">
                        <h4 class="text-sm font-semibold text-gray-100 truncate">{{ defenderSelectedData.name }}</h4>
                      </div>
                      <div class="mt-2">
                        <div class="flex items-center justify-between text-xxs text-gray-400">
                          <span>HP</span>
                          <span class="font-mono text-gray-200">{{ getHp(defenderSelectedData) }} / {{ getMaxHp(defenderSelectedData) }}</span>
                        </div>
                        <div class="relative w-full bg-gray-500 h-5 rounded overflow-hidden mt-1">
                          <div class="absolute inset-y-0 left-0 bg-blue-600" :style="{ width: (getHp(defenderSelectedData) / getMaxHp(defenderSelectedData) * 100) + '%' }"></div>
                        </div>
                      </div>
                      <div class="mt-2 grid grid-cols-3 gap-1 text-xxs text-gray-300">
                        <div class="px-2 py-1 rounded bg-gray-800 border border-gray-700">STA ??</div>
                        <div class="px-2 py-1 rounded bg-gray-800 border border-gray-700">STR ??</div>
                        <div class="px-2 py-1 rounded bg-gray-800 border border-gray-700">INT ??</div>
                        <div class="px-2 py-1 rounded bg-gray-800 border border-gray-700">AGI ??</div>
                        <div class="px-2 py-1 rounded bg-gray-800 border border-gray-700">LUCK ??</div>
                        <div class="px-2 py-1 rounded bg-gray-800 border border-gray-700">DEF ??</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Combat Log -->
              <div class="bg-gray-900 border border-gray-700 rounded-md p-4">
                <div class="flex items-center justify-between mb-2">
                  <h3 class="text-xs font-semibold text-indigo-200"><i class="fa-solid fa-scroll"></i> บันทึกการต่อสู้</h3>
                  <span class="text-xxs text-gray-400" v-if="eventData?.finished">สรุปผลแล้ว</span>
                  <span class="text-xxs text-gray-400" v-else>กำลังดำเนินการ</span>
                </div>
                <div class="max-h-40 overflow-y-auto space-y-1 scrollbar-thin">
                  <p v-if="!fightResult.length" class="text-xs text-gray-400 text-center py-4">
                    ยังไม่มีผลการทอย แสดงผลลัพธ์ที่นี่เมื่อกด “ทอยลูกเต๋าต่อสู้”
                  </p>
                  <div v-else v-for="(res, index) in fightResult" :key="index" class="text-xs text-gray-200 flex items-start space-x-2">
                    <i class="fa-solid fa-chevron-right mt-1 text-gray-500 text-xxs"></i>
                    <span>{{ res.message }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- TAB: ATTACKERS -->
            <div v-if="activeTab === 'attackers'" class="bg-gray-900 border border-gray-700 rounded-md p-4">
              <div class="flex items-center justify-between mb-2">
                <h3 class="text-xs font-semibold text-red-300"><i class="fa-solid fa-fire-flame-curved"></i> ชาวบ้านฝั่งบุก (Attackers)</h3>
                <div class="text-xxs text-gray-400">{{ eventData?.attackers?.length || 0 }} ตัว</div>
              </div>

              <!-- แถบรวม (เฉพาะฝ่ายบุก) -->
              <div v-if="attackersData.length" class="space-y-2 mb-4">
                <div class="flex items-center justify-between text-xs text-gray-300">
                  <span class="px-2 py-1 rounded bg-red-700 text-white text-xxs">พลังชีวิตรวมฝ่ายบุก</span>
                  <span class="font-mono text-gray-100">{{ totalAtkHp }} / {{ totalAtkMax }}</span>
                </div>
                <div class="relative w-full bg-gray-500 h-5 rounded overflow-hidden">
                  <div class="absolute inset-y-0 left-0 bg-red-600" :style="{ width: (totalAtkMax ? (totalAtkHp / totalAtkMax) * 100 : 0) + '%' }"></div>
                </div>
              </div>

              <div v-if="attackersData.length" class="grid grid-cols-1 gap-3">
                <div
                  v-for="att in attackersData"
                  :key="att.id"
                  class="bg-gray-800 rounded-md border border-gray-700 p-3 transition hover:border-indigo-500"
                >
                  <div class="flex items-center justify-between mb-2">
                    <div class="flex items-center space-x-2">
                      <span class="px-2 py-1 rounded bg-red-700 text-white text-xxs">Attacker</span>
                      <span class="text-xs text-gray-200 font-semibold">{{ att.name }}</span>
                    </div>
                    <div class="text-xxs text-gray-400" v-if="att?.level || gameVillagersData?.[att?.templateId]?.level">
                      Lv. {{ att?.level ?? gameVillagersData?.[att?.templateId]?.level }}
                    </div>
                  </div>
                  <div class="flex items-center space-x-3">
                    <img
                      :src="att?.img || gameVillagersData?.[att?.templateId]?.normalFace || 'https://via.placeholder.com/64?text=No+Img'"
                      :alt="att.name" class="w-14 h-14 rounded-md object-cover border-2 border-red-600 bg-gray-900"
                      @error="handleImageError"
                    />
                    <div class="flex-1 min-w-0">
                      <div class="relative w-full bg-gray-500 h-5 rounded overflow-hidden mb-1">
                        <div class="absolute inset-y-0 left-0 bg-red-600 rounded" :style="{ width: (getHp(att) / getMaxHp(att) * 100) + '%' }"></div>
                      </div>
                      <div class="text-xxs text-gray-300">
                        HP: <span class="font-mono text-gray-100">{{ getHp(att) }} / {{ getMaxHp(att) }}</span>
                      </div>
                      <div class="mt-2 flex items-center space-x-2">
                        <span class="px-2 py-1 rounded bg-red-900 bg-opacity-50 border border-red-700 text-white text-xxs">
                          <i class="fa-solid fa-dice"></i> ATK 6
                        </span>
                        <span class="px-2 py-1 rounded bg-blue-900 bg-opacity-50 border border-blue-700 text-white text-xxs">
                          <i class="fa-solid fa-dice"></i> DEF 6
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="mt-2">
                    <div class="grid grid-cols-3 gap-1 text-xxs text-gray-300">
                      <div class="px-2 py-1 rounded bg-gray-800 border border-gray-700">STA {{ getTotalStat(att, 'stamina') }}</div>
                      <div class="px-2 py-1 rounded bg-gray-800 border border-gray-700">STR {{ getTotalStat(att, 'str') }}</div>
                      <div class="px-2 py-1 rounded bg-gray-800 border border-gray-700">AGI {{ getTotalStat(att, 'agi') }}</div>
                      <div class="px-2 py-1 rounded bg-gray-800 border border-gray-700">INT {{ getTotalStat(att, 'int') }}</div>
                      <div class="px-2 py-1 rounded bg-gray-800 border border-gray-700">LUCK {{ getTotalStat(att, 'luck') }}</div>
                      <div class="px-2 py-1 rounded bg-gray-800 border border-gray-700">DEF {{ getTotalStat(att, 'defense') }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <p v-else class="text-gray-300 text-xs text-center py-6">—</p>
            </div>

            <!-- TAB: DEFENDERS -->
            <div v-if="activeTab === 'defenders'" class="bg-gray-900 border border-gray-700 rounded-md p-4">
              <div class="flex items-center justify-between mb-2">
                <h3 class="text-xs font-semibold text-blue-300"><i class="fa-solid fa-shield-alt"></i> ชาวบ้านฝั่งป้องกัน (Defenders)</h3>
                <div class="text-xxs text-gray-400">{{ Object.keys(eventData?.defenders || {}).length || 0 }} ตัว</div>
              </div>

              <!-- แถบรวม (เฉพาะฝ่ายป้องกัน) -->
              <div v-if="defendersData.length" class="space-y-2 mb-4">
                <div class="flex items-center justify-between text-xs text-gray-300">
                  <span class="px-2 py-1 rounded bg-blue-700 text-white text-xxs">พลังชีวิตรวมฝ่ายป้องกัน</span>
                  <span class="font-mono text-gray-100">{{ totalDefHp }} / {{ totalDefMax }}</span>
                </div>
                <div class="relative w-full bg-gray-500 h-5 rounded overflow-hidden">
                  <div class="absolute inset-y-0 left-0 bg-blue-600" :style="{ width: (totalDefMax ? (totalDefHp / totalDefMax) * 100 : 0) + '%' }"></div>
                </div>
              </div>

              <div v-if="defendersData.length" class="grid grid-cols-1 gap-3">
                <div
                  v-for="def in defendersData"
                  :key="def.id"
                  class="bg-gray-800 rounded-md border border-gray-700 p-3 transition hover:border-indigo-500"
                >
                  <div class="flex items-center justify-between mb-2">
                    <div class="flex items-center space-x-2">
                      <span class="px-2 py-1 rounded bg-blue-700 text-white text-xxs">Defender</span>
                      <span class="text-xs text-gray-200 font-semibold">{{ def.name }}</span>
                    </div>
                    <div class="text-xxs text-gray-400" v-if="def?.level || gameVillagersData?.[def?.templateId]?.level">
                      Lv. {{ def?.level ?? gameVillagersData?.[def?.templateId]?.level }}
                    </div>
                  </div>
                  <div class="flex items-center space-x-3">
                    <img
                      :src="def?.img || gameVillagersData?.[def?.templateId]?.normalFace || 'https://via.placeholder.com/64?text=No+Img'"
                      :alt="def.name" class="w-14 h-14 rounded-md object-cover border-2 border-blue-600 bg-gray-900"
                      @error="handleImageError"
                    />
                    <div class="flex-1 min-w-0">
                      <div class="relative w-full bg-gray-500 h-5 rounded overflow-hidden mb-1">
                        <div class="absolute inset-y-0 left-0 bg-blue-600 rounded" :style="{ width: (getHp(def) / getMaxHp(def) * 100) + '%' }"></div>
                      </div>
                      <div class="text-xxs text-gray-300">
                        HP: <span class="font-mono text-gray-100">{{ getHp(def) }} / {{ getMaxHp(def) }}</span>
                      </div>
                      <div class="mt-2 flex items-center space-x-2">
                        <span class="px-2 py-1 rounded bg-red-900 bg-opacity-50 border border-red-700 text-white text-xxs">
                          <i class="fa-solid fa-dice"></i> ATK 6
                        </span>
                        <span class="px-2 py-1 rounded bg-blue-900 bg-opacity-50 border border-blue-700 text-white text-xxs">
                          <i class="fa-solid fa-dice"></i> DEF 6
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="mt-2">
                    <div class="grid grid-cols-3 gap-1 text-xxs text-gray-300">
                      <div class="px-2 py-1 rounded bg-gray-800 border border-gray-700">STA ??</div>
                      <div class="px-2 py-1 rounded bg-gray-800 border border-gray-700">STR ??</div>
                      <div class="px-2 py-1 rounded bg-gray-800 border border-gray-700">AGI ??</div>
                      <div class="px-2 py-1 rounded bg-gray-800 border border-gray-700">INT ??</div>
                      <div class="px-2 py-1 rounded bg-gray-800 border border-gray-700">LUCK ??</div>
                      <div class="px-2 py-1 rounded bg-gray-800 border border-gray-700">DEF ??</div>
                    </div>
                  </div>
                </div>
              </div>

              <p v-else class="text-gray-300 text-xs text-center py-6">—</p>
            </div>
          </section>
        </main>
      </div>
    </div>
  </teleport>
</template>

<script>
import { ref, watch, onMounted, onBeforeUnmount, computed } from 'vue'
import { projectFirestore, projectFunctions } from '@/firebase/config'
import gameVillagersData from '@/data/gameVillagers.json'

export default {
  name: 'AttackOutpostModal',
  props: {
    eventId: { type: String, required: true }
  },
  emits: ['close'],
  setup (props, { emit }) {
    const eventData = ref(null)
    const attackersData = ref([])
    const defendersData = ref([])
    const attackerSelectedData = ref(null)
    const defenderSelectedData = ref(null)
    const fightResult = ref([])
    const isProcessing = ref(false)
    const isRolling = ref(false)
    const attackerDiceResults = ref([])
    const defenderDiceResults = ref([])
    const tempAttackerDices = ref([])
    const tempDefenderDices = ref([])
    const activeTab = ref('current')
    const timeLeft = ref('')
    const isAutoRolling = ref(false)
    const autoRollIntervalMs = ref(null)
    let stop = null
    let prevBodyOverflow = ''
    let diceInterval = null
    let autoRollInterval = null
    const NO_GRACE_MS = 30000 // Grace period if no fighters (rare case)
    let noFighterSince = null

    const subscribe = (id) => {
      if (stop) stop()
      eventData.value = null
      const docRef = projectFirestore.collection('events').doc(id)
      stop = docRef.onSnapshot(
        snap => { if (snap.exists) eventData.value = snap.data() },
        err => { console.error(err) }
      )
    }

    const emitClose = () => { emit('close') }
    const onKey = (e) => { if (e.key === 'Escape') emitClose() }
    const handleImageError = (e) => { e.target.src = 'https://via.placeholder.com/64?text=No+Img' }

    const getTotalStat = (v, key) => {
      const base = v?.stats?.[key] || 0
      const upgrade = v?.upgradeStats?.[key] || 0
      return base + upgrade
    }

    const getDice = (v, key) => {
      const tpl = gameVillagersData?.[v?.templateId] || {}
      return v?.[key] || tpl?.[key] || 0
    }
    const getMaxHp = (v) => getTotalStat(v, 'stamina') * 20
    const getHp = (v) => Math.max(0, getMaxHp(v) - (v?.damageTaken || 0))

    const formatExpires = (expiresAt) => {
      if (!expiresAt) return 'ไม่ทราบ'
      const remaining = expiresAt.toDate().getTime() - Date.now()
      if (remaining <= 0) return 'หมดเวลาแล้ว'
      const m = Math.floor(remaining / 60000)
      const s = Math.floor((remaining % 60000) / 1000)
      return `${m}:${s.toString().padStart(2, '0')}`
    }

    const updateTimeLeft = () => {
      timeLeft.value = formatExpires(eventData.value?.expiresAt)
    }

    const loadData = async () => {
      const atkObj = eventData.value?.attackers || {}
      const defObj = eventData.value?.defenders || {}
      attackersData.value = Object.entries(atkObj).map(([id, v]) => {
        const tpl = gameVillagersData[v.templateId] || {}
        return { id, ...tpl, ...v }
      })
      defendersData.value = Object.entries(defObj).map(([id, v]) => {
        const tpl = gameVillagersData[v.templateId] || {}
        return { id, ...tpl, ...v }
      })
      attackerSelectedData.value = attackersData.value.find(a => a.id === eventData.value?.attackerSelected) || null
      defenderSelectedData.value = defendersData.value.find(d => d.id === eventData.value?.defenderSelected) || null
    }

    const startDiceAnimation = () => {
      isRolling.value = true
      const atkDiceCount = 6
      const defDiceCount = 6
      tempAttackerDices.value = Array.from({ length: atkDiceCount }, () => Math.floor(Math.random() * 6) + 1)
      tempDefenderDices.value = Array.from({ length: defDiceCount }, () => Math.floor(Math.random() * 6) + 1)
      diceInterval = setInterval(() => {
        tempAttackerDices.value = Array.from({ length: atkDiceCount }, () => Math.floor(Math.random() * 6) + 1)
        tempDefenderDices.value = Array.from({ length: defDiceCount }, () => Math.floor(Math.random() * 6) + 1)
      }, 100)
    }

    const stopDiceAnimation = () => {
      if (diceInterval) {
        clearInterval(diceInterval)
        diceInterval = null
      }
      isRolling.value = false
    }

    const fightRound = async () => {
      isProcessing.value = true
      startDiceAnimation()
      try {
        // Wait for 2 seconds
        await new Promise(resolve => setTimeout(resolve, 2000))
        const { data } = await projectFunctions.httpsCallable('gameActions')({
          action: 'outpostActions',
          subAction: 'fightOutpostRound',
          eventId: props.eventId
        })
        stopDiceAnimation()
        if (data?.success) {
          fightResult.value = data.fightResult
          attackerDiceResults.value = data.attackerRolls || []
          defenderDiceResults.value = data.defenderRolls || []
        } else {
          console.error(data?.error)
        }
      } catch (e) {
        stopDiceAnimation()
        console.error('Error in fight round:', e)
      } finally {
        isProcessing.value = false
      }
    }

    // === Auto Roll Functions (คล้าย auto-attack ใน zombie modal) ===
    const toggleAutoRoll = (intervalMs) => {
      if (isAutoRolling.value) {
        stopAutoRoll('ผู้เล่นปิด Auto Roll')
      } else {
        startAutoRoll(intervalMs)
      }
    }

    const startAutoRoll = (intervalMs) => {
      if (isAutoRolling.value) return
      isAutoRolling.value = true
      autoRollIntervalMs.value = intervalMs
      noFighterSince = null
      if (autoRollInterval) clearInterval(autoRollInterval)
      autoRollInterval = setInterval(async () => {
        if (eventData.value?.finished) {
          stopAutoRoll('การต่อสู้สิ้นสุดแล้ว: Auto Roll หยุด')
          return
        }
        if (!attackerSelectedData.value || !defenderSelectedData.value) {
          if (noFighterSince == null) noFighterSince = Date.now()
          const waiting = Date.now() - noFighterSince
          if (waiting >= NO_GRACE_MS) {
            stopAutoRoll('ไม่มีผู้ต่อสู้: Auto Roll หยุด')
          }
          return
        } else {
          noFighterSince = null
        }
        if (!isProcessing.value) {
          try {
            await fightRound()
          } catch (e) {
            console.error('Error in auto roll:', e)
            // Optionally stop on error
          }
        }
      }, intervalMs)
    }

    const stopAutoRoll = (reason = '') => {
      if (autoRollInterval) {
        clearInterval(autoRollInterval)
        autoRollInterval = null
      }
      isAutoRolling.value = false
      autoRollIntervalMs.value = null
      if (reason) console.log(reason) // หรือแสดงใน UI ถ้าต้องการ
    }

    /* === รวมพลังชีวิต (ทีม) === */
    const sumRemainHp = (list) => (list || []).reduce((acc, v) => acc + getHp(v), 0)
    const sumMaxHp = (list) => (list || []).reduce((acc, v) => acc + getMaxHp(v), 0)

    const totalAtkHp = computed(() => sumRemainHp(attackersData.value))
    const totalDefHp = computed(() => sumRemainHp(defendersData.value))
    const totalAtkMax = computed(() => sumMaxHp(attackersData.value))
    const totalDefMax = computed(() => sumMaxHp(defendersData.value))
    const totalAllHp = computed(() => totalAtkHp.value + totalDefHp.value)
    const atkPct = computed(() => totalAllHp.value ? (totalAtkHp.value / totalAllHp.value) * 100 : 0)
    const defPct = computed(() => totalAllHp.value ? (totalDefHp.value / totalAllHp.value) * 100 : 0)

    // === สรุปผลรอบ ===
    const attackerSum = computed(() =>
      (attackerDiceResults.value || []).reduce((s, v) => s + v, 0)
    )
    const defenderSum = computed(() =>
      (defenderDiceResults.value || []).reduce((s, v) => s + v, 0)
    )
    const attackerDiceCount = computed(() =>
      Math.max(1, getDice(attackerSelectedData.value, 'attackDice') || 0)
    )
    const defenderDiceCount = computed(() =>
      Math.max(1, getDice(defenderSelectedData.value, 'defenseDice') || 0)
    )
    const winnerSide = computed(() => {
      if (isProcessing.value) return null
      if (!attackerDiceResults.value.length && !defenderDiceResults.value.length) return null
      if (attackerSum.value > defenderSum.value) return 'attacker'
      if (defenderSum.value > attackerSum.value) return 'defender'
      return 'draw'
    })
    const winnerLabel = computed(() =>
      winnerSide.value === 'attacker' ? 'ฝ่ายบุกชนะรอบนี้'
      : winnerSide.value === 'defender' ? 'ฝ่ายป้องกันชนะรอบนี้'
      : 'เสมอ'
    )
    const winnerSideIcon = computed(() =>
      winnerSide.value === 'attacker' ? 'fa-trophy'
      : winnerSide.value === 'defender' ? 'fa-shield-halved'
      : 'fa-scale-balanced'
    )

    // === ข้อมูล UI ของฝ่ายที่ได้โบนัส (สำหรับดีไซน์ใหม่) ===
    const specialEvent = computed(() => eventData.value?.specialEvent || null)
    const currentRound = computed(() => (eventData.value?.round || 0) + 1)

    const bonusSideLabel = computed(() =>
      specialEvent.value?.bonusSide === 'attacker' ? 'ฝ่ายบุก' :
      specialEvent.value?.bonusSide === 'defender' ? 'ฝ่ายป้องกัน' : '—'
    )
    const bonusSideIcon = computed(() =>
      specialEvent.value?.bonusSide === 'attacker'
        ? 'fa-fire-flame-curved'
        : specialEvent.value?.bonusSide === 'defender'
          ? 'fa-shield-halved'
          : 'fa-circle'
    )
    // ใช้คลาส inline (ไม่พึ่ง @apply)
    const bonusSideClassInline = computed(() => {
      const base = 'border-opacity-40';
      if (specialEvent.value?.bonusSide === 'attacker') {
        return `bg-red-600 bg-opacity-20 text-red-200 border-red-500 ${base}`
      } else if (specialEvent.value?.bonusSide === 'defender') {
        return `bg-blue-600 bg-opacity-20 text-blue-200 border-blue-500 ${base}`
      }
      return `bg-gray-800 text-gray-200 border-gray-700`
    })

    // === จำนวนที่เหลืออยู่สำหรับ tabs ===
    const attackersAlive = computed(() => attackersData.value.filter(v => getHp(v) > 0).length)
    const defendersAlive = computed(() => defendersData.value.filter(v => getHp(v) > 0).length)

    const tabs = computed(() => [
      { id: 'current', name: 'ภาพรวม', icon: 'fas fa-fist-raised' },
      { id: 'attackers', name: `ฝ่ายบุก(${attackersAlive.value})`, icon: 'fas fa-users' },
      { id: 'defenders', name: `ฝ่ายป้องกัน(${defendersAlive.value})`, icon: 'fas fa-shield-alt' }
    ])

    onMounted(() => {
      subscribe(props.eventId)
      document.addEventListener('keydown', onKey)
      prevBodyOverflow = document.body.style.overflow
      document.body.style.overflow = 'hidden'
      const timeInterval = setInterval(updateTimeLeft, 1000)
      onBeforeUnmount(() => clearInterval(timeInterval))
    })
    watch(() => props.eventId, (id) => { if (id) subscribe(id) })
    watch(eventData, async () => { if (eventData.value) await loadData() })

    onBeforeUnmount(() => {
      if (stop) stop()
      document.removeEventListener('keydown', onKey)
      document.body.style.overflow = prevBodyOverflow || ''
      stopDiceAnimation()
      stopAutoRoll()
    })

    return {
      eventData, attackersData, defendersData,
      attackerSelectedData, defenderSelectedData,
      fightResult, isProcessing, isRolling, activeTab, tabs,
      attackerDiceResults, defenderDiceResults, tempAttackerDices, tempDefenderDices,
      emitClose, handleImageError, getTotalStat, getDice, getMaxHp, getHp, formatExpires, fightRound,
      totalAtkHp, totalDefHp, totalAtkMax, totalDefMax, totalAllHp, atkPct, defPct,
      timeLeft,
      attackerSum, defenderSum, attackerDiceCount, defenderDiceCount,
      winnerSide, winnerLabel, winnerSideIcon,
      specialEvent, currentRound,
      bonusSideLabel, bonusSideIcon, bonusSideClassInline,
      toggleAutoRoll, isAutoRolling, autoRollIntervalMs,
      gameVillagersData
    }
  }
}
</script>

<style scoped>
/* Custom Scrollbar */
.scrollbar-thin::-webkit-scrollbar { width: 5px; }
.scrollbar-thin::-webkit-scrollbar-track { background: #2d3748; border-radius: 10px; }
.scrollbar-thin::-webkit-scrollbar-thumb { background: #4a5568; border-radius: 10px; }
.scrollbar-thin::-webkit-scrollbar-thumb:hover { background: #6b7280; }
.scrollbar-thin { scrollbar-width: thin; scrollbar-color: #4a5568 #2d3748; }

/* Animations */
@keyframes modalFade { from { opacity: 0; } to { opacity: 1; } }
.animate-modalFade { animation: modalFade 0.25s ease-out; }

@keyframes scaleIn { from { transform: scale(0.97); opacity: 0; } to { transform: 1; opacity: 1; } }
.animate-scaleIn { animation: scaleIn 0.25s ease-out; }

@keyframes fadeIn { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }
.animate-fadeIn { animation: fadeIn 0.25s ease-out; }

@keyframes tabSlide { from { width: 0; } to { width: 100%; } }
.animate-tabSlide { animation: tabSlide 0.2s ease-out; }

/* Utility tweaks */
.text-xxs { font-size: 0.68rem; line-height: 1rem; }

/* ---- (เดิม) Dice 3D styles: ยังเก็บไว้หากต้องการกลับไปใช้ ---- */
.cube {
  position: relative;
  width: 40px;
  height: 40px;
  transform-style: preserve-3d;
  transition: transform 1s;
  margin: 0 auto;
  perspective: 800px;
}
.cube .face {
  position: absolute;
  width: 40px;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.2);
  backface-visibility: hidden;
}
.cube .face.front { transform: rotateY(0deg) translateZ(20px); }
.cube .face.back { transform: rotateY(180deg) translateZ(20px); }
.cube .face.right { transform: rotateY(90deg) translateZ(20px); }
.cube .face.left { transform: rotateY(-90deg) translateZ(20px); }
.cube .face.top { transform: rotateX(90deg) translateZ(20px); }
.cube .face.bottom { transform: rotateX(-90deg) translateZ(20px); }
.attacker-cube .face {
  background: linear-gradient(145deg, #ef4444, #b91c1c);
}
.defender-cube .face {
  background: linear-gradient(145deg, #3b82f6, #1e40af);
}
@keyframes diceRoll {
  0% { transform: rotateX(0deg) rotateY(0deg); }
  100% { transform: rotateX(360deg) rotateY(360deg); }
}
.animate-dice-roll { animation: diceRoll 1s linear infinite; }
.delay-200 { animation-delay: 0.2s; }

/* ---- (ใหม่) Badges + Dice Chips แบบกระชับ ---- */
.badge {
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 0.68rem;
  font-weight: 600;
  border: 1px solid;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.badge-red { background: rgba(185,28,28,0.55); border-color: #7f1d1d; color: #fde2e2; }
.badge-blue { background: rgba(30,64,175,0.55); border-color: #1e3a8a; color: #dbeafe; }

.dice-row { display: flex; flex-wrap: wrap; gap: 6px; }
.die {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 28px;
  padding: 0 8px;
  border-radius: 8px;
  font-weight: 700;
  font-size: 0.85rem;
  border: 1px solid rgba(255,255,255,0.12);
  box-shadow: inset 0 -1px 0 rgba(0,0,0,0.2);
}
.die-red { background: linear-gradient(160deg,#b91c1c,#7f1d1d); color:#fff; }
.die-blue { background: linear-gradient(160deg,#1e40af,#172554); color:#fff; }

@keyframes shimmer {
  0% { opacity: .6; transform: translateY(0); }
  50% { opacity: 1; transform: translateY(-1px); }
  100% { opacity: .6; transform: translateY(0); }
}
.shimmer { animation: shimmer .9s ease-in-out infinite; }

.line-clamp-2 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.mono { font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono","Courier New", monospace; }

/* Scrollbar (ซ้ำจากบนเพื่อรองรับ scoped) */
.scrollbar-thin::-webkit-scrollbar {
  width: 5px;
}
.scrollbar-thin::-webkit-scrollbar-track {
  background: #2d3748;
  border-radius: 10px;
}
.scrollbar-thin::-webkit-scrollbar-thumb {
  background: #4a5568;
  border-radius: 10px;
}
.scrollbar-thin::-webkit-scrollbar-thumb:hover {
  background: #6b7280;
}
.scrollbar-thin {
  scrollbar-width: thin;
  scrollbar-color: #4a5568 #2d3748;
}
/* Animations (ซ้ำจากบนเพื่อรองรับ scoped) */
@keyframes modalFade {
  from { opacity: 0; }
  to { opacity: 1; }
}
.animate-modalFade {
  animation: modalFade 0.3s ease-out;
}
@keyframes scaleIn {
  from { transform: scale(0.95); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}
.animate-scaleIn {
  animation: scaleIn 0.3s ease-out;
}
@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.2); }
  100% { transform: scale(1); }
}
.animate-pulse {
  animation: pulse 1.5s infinite;
}
@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-4px); }
}
.animate-bounce {
  animation: bounce 0.5s infinite;
}
@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
@keyframes spin-pulse {
  0% { transform: rotate(0deg) scale(1); }
  50% { transform: rotate(180deg) scale(1.2); }
  100% { transform: rotate(360deg) scale(1); }
}
.animate-spin-pulse {
  animation: spin-pulse 1.2s ease-in-out infinite;
}
/* Button States */
button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
/* Responsive */
@media (max-width: 640px) {
  .text-sm {
    font-size: 0.75rem;
  }
  .text-xs {
    font-size: 0.625rem;
  }
  .p-4 {
    padding: 0.75rem;
  }
  .w-16 {
    width: 3rem;
    height: 3rem;
  }
  .max-h-64 {
    max-height: 16rem;
  }
}
/* Fade/slide for item list */
.fade-list-enter-active,outpostActions2
.fade-list-leave-active {
  transition: opacity 200ms ease, transform 200ms ease;
}
.fade-list-enter-from,
.fade-list-leave-to {
  opacity: 0;
  transform: translateY(4px);
}
/* Custom text size */
.text-xxs {
  font-size: 10px;
  line-height: 1rem;
}
</style>